<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/horizontal'
import PageHeader from '@components/page-header'
import PortNameList from '@components/port-name/port-name-list'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PortName',
  page: {
    title: 'Port Name',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    PortNameList,
  },
  data() {
    return {
      title: 'Port Name',
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'port-name',
          active: true,
        },
      ],
    }
  },
  computed: {
    ...mapGetters('portName', ['allPortNames']),
  },
  created() {
    this.getPortNames()
  },
  methods: {
    ...mapActions('portName', ['getPortNames']),
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <PortNameList :port-names="allPortNames" />
  </Layout>
</template>
